/**
 * @fileoverview WhatsNewDialog — Foundry's "What's new in {product}" release
 * notes modal. Blueprint Dialog with a custom in-body layout: a
 * WhatsNewDialogHeader at the top, a ReleaseNoteScrollArea of
 * ReleaseNoteRow children, and a fixed WhatsNewDialogFooter. The
 * component is structural — consumers pass header/scroll/footer slots
 * so they can compose any combination of rows and terminators.
 *
 * Foundry mapping: `release-notes__whats-new-dialog__d8vw8g` +
 * `release-notes__whats-new-dialog-body__1g6dw2s`.
 */

import { Dialog } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface WhatsNewDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  /** Required: a <WhatsNewDialogHeader />. */
  header: ReactNode;
  /** Required: a <ReleaseNoteScrollArea> containing ReleaseNoteRow children. */
  scrollArea: ReactNode;
  /** Required: a <WhatsNewDialogFooter />. */
  footer: ReactNode;
  className?: string;
}

export function WhatsNewDialog({
  isOpen,
  onClose,
  header,
  scrollArea,
  footer,
  className,
}: WhatsNewDialogProps): ReactElement {
  return (
    <Dialog data-testid="whats-new-dialog"
      isOpen={isOpen}
      onClose={onClose}
      className={["bp-whats-new-dialog", className].filter(Boolean).join(" ")}
    >
      <div className="bp-whats-new-dialog-body">
        {header}
        {scrollArea}
      </div>
      {footer}
    </Dialog>
  );
}
